/**
 * Shop by Category — 8 image-free icon tiles linking to the live menu
 * prefiltered by category.
 */
import { Link } from "react-router-dom";
import {
    ArrowUpRight,
    Leaf,
    Flower2,
    Cigarette,
    Wind,
    Cookie,
    FlaskConical,
    Droplet,
    Sparkles,
    Package,
} from "lucide-react";

const ICON_MAP = {
    FLOWER: Flower2,
    PRE_ROLLS: Cigarette,
    VAPORIZERS: Wind,
    EDIBLES: Cookie,
    CONCENTRATES: FlaskConical,
    TINCTURES: Droplet,
    TOPICALS: Sparkles,
    ACCESSORIES: Package,
};

export default function HomeCategoryGrid({ categories }) {
    return (
        <section
            data-testid="category-grid"
            className="relative py-10 sm:py-14 px-6 sm:px-10 bg-zen-bg border-t border-zen-ink/8"
        >
            <div className="max-w-[1400px] mx-auto">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 gap-4">
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.35em] text-zen-olive mb-3">
                            Shop by category
                        </p>
                        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light text-zen-ink leading-[1.05] max-w-2xl">
                            Curated for every kind of moment.
                        </h2>
                    </div>
                    <Link
                        to="/menu/queens-long-island"
                        className="zen-link text-[12px] uppercase tracking-[0.25em] text-zen-ink-soft hover:text-zen-ink inline-flex items-center gap-2 shrink-0"
                    >
                        View full menu <ArrowUpRight size={14} />
                    </Link>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2 sm:gap-3">
                    {categories.map((c) => {
                        const Icon = ICON_MAP[c.slug] || Leaf;
                        return (
                            <Link
                                key={c.slug}
                                to={`/menu/queens-long-island?category=${c.slug}`}
                                data-testid={`category-${c.slug.toLowerCase()}`}
                                className="group relative aspect-square bg-zen-surface border border-zen-ink/10 hover:border-zen-olive hover:bg-zen-bg transition-all duration-500 p-4 sm:p-5 flex flex-col justify-between overflow-hidden"
                            >
                                <Icon
                                    size={28}
                                    strokeWidth={1.3}
                                    className="text-zen-olive group-hover:scale-110 transition-transform duration-500"
                                />
                                <div>
                                    <h3 className="font-serif text-lg sm:text-xl text-zen-ink font-light leading-tight mb-1 tracking-tight">
                                        {c.name}
                                    </h3>
                                    <p className="text-[10px] uppercase tracking-[0.22em] text-zen-ink-soft leading-snug line-clamp-2">
                                        {c.tagline}
                                    </p>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
